import Article1Component from '../components/articles/article/article1/Article1Component';
import Article2Component from '../components/articles/article/article2/Article2Component';
import Article3Component from '../components/articles/article/article3/Article3Component';
import Article4Component from '../components/articles/article/article4/Article4Component';
import Article5Component from '../components/articles/article/article5/Article5Component';
import Article6Component from '../components/articles/article/article6/Article6Component';
import Article7Component from '../components/articles/article/article7/Article7Component';
import Article8Component from '../components/articles/article/article8/Article8Component';
import Article9Component from '../components/articles/article/article9/Article9Component';
import Article10Component from '../components/articles/article/article10/Article10Component';
import FirstImg from '../assets/images/articles/articles-cover-images/How Retailers Can Use Beacon Discovery to Prepare for Newtopia Now .png';
import SecondImg from '../assets/images/articles/articles-cover-images/Stand Out at Newtopia Now 2025 with Beacon Discovery.jpg';
import ThirdImg from '../assets/images/articles/articles-cover-images/How IΓÇÖm Using Beacon Discovery to Prepare for Expo West 2025.jpg';
import FourthImg from '../assets/images/articles/articles-cover-images/Maximize Your Natural Products Expo West Experience with Beacon Discovery!.jpg';
import FifthImg from '../assets/images/articles/articles-cover-images/Exciting News- Business Providers Can Now Join Beacon Discovery! .png';
import SixthImg from '../assets/images/articles/articles-cover-images/New Hope NetworkΓÇÖs Market Integrity Group ΓÇô Who We Are.jpg';
import SeventhImg from '../assets/images/articles/articles-cover-images/Integrity in Sustainability Claims.webp';
import EightImg from '../assets/images/articles/articles-cover-images/NBJ Summit partners with HowGood to provide carbon footprints for meals at the event.png';
import NineImg from '../assets/images/articles/articles-cover-images/Make Connections with Beacon.webp';
import TenthImg from '../assets/images/articles/articles-cover-images/How to get your brand noticed on Beacon Discovery.webp';

export interface IPropsArticle {
	id: any;
	title: string;
	date: string;
	coverImage: string;
	content: React.JSX.Element;
	isContain: boolean;
	isFill: boolean;
}

export const AVAILABLE_ARTICLES: IPropsArticle[] = [
	{
		id: '1',
		title: 'How Retailers Can Use Beacon Discovery to Prepare for Newtopia Now',
		date: 'April 15, 2025',
		coverImage: FirstImg,
		content: <Article1Component />,
		isContain: false,
		isFill: false
	},
	{
		id: '2',
		title: 'Stand Out at Newtopia Now 2025 with Beacon Discovery',
		date: 'April 9, 2025',
		coverImage: SecondImg,
		content: <Article2Component />,
		isContain: false,
		isFill: false
	},
	{
		id: '3',
		title: 'How Im Using Beacon Discovery to Prepare for Expo West 2025',
		date: 'January 30, 2025',
		coverImage: ThirdImg,
		content: <Article3Component />,
		isContain: false,
		isFill: false
	},
	{
		id: '4',
		title: 'Maximize Your Natural Products Expo West Experience with Beacon Discovery',
		date: 'January 27, 2025',
		coverImage: FourthImg,
		content: <Article4Component />,
		isContain: false,
		isFill: true
	},
	{
		id: '5',
		title: 'Exciting News: Business Providers Can Now Join Beacon Discovery',
		date: 'February 27, 2025',
		coverImage: FifthImg,
		content: <Article5Component />,
		isContain: false,
		isFill: true
	},
	{
		id: '6',
		title: 'New Hope Network’s Market Integrity Group: Who We Are',
		date: 'July 10, 2023',
		coverImage: SixthImg,
		content: <Article6Component />,
		isContain: true,
		isFill: false
	},
	{
		id: '7',
		title: 'Integrity in Sustainability Claims: HowGood Is My Product?',
		date: 'August 1, 2023',
		coverImage: SeventhImg,
		content: <Article7Component />,
		isContain: true,
		isFill: false
	},
	{
		id: '8',
		title: 'NBJ Summit partners with HowGood to provide carbon footprints for meals at the eventry',
		date: 'July 24, 2024',
		coverImage: EightImg,
		content: <Article8Component />,
		isContain: false,
		isFill: false
	},
	{
		id: '9',
		title: 'Make authentic connections through new Beacon Discovery tool',
		date: 'June 12, 2024',
		coverImage: NineImg,
		content: <Article9Component />,
		isContain: false,
		isFill: false
	},
	{
		id: '10',
		title: 'How to get your brand noticed on Beacon Discovery',
		date: 'May 1, 2024',
		coverImage: TenthImg,
		content: <Article10Component />,
		isContain: false,
		isFill: true
	}
];
